import UPDATE_PRODUCT_SEARCH_FOCUS_CLASS from '../actionTypes/ProductSearchFocusActionTypes';

function ProductSearchFocusReducer(state = '', action = {}) {
    switch (action.type) {
        case UPDATE_PRODUCT_SEARCH_FOCUS_CLASS: {
            return action.payload;
        }
        default:
            return state;
    }
}

ProductSearchFocusReducer.reducerName = 'productSearchFocus';
export default ProductSearchFocusReducer;
